import type { Site } from '@hotjar/site';
import { trackingCodeInstallerOpened } from '@hotjar/webapp/tracking/common';
import { bus, trackingCodeModalOpened } from '@hotjar/webapp/utils/events';
import { getState } from '@hotjar/webapp/domains/activation/tracking-code';
import { noop } from '@hotjar/webapp/lib/function';
import { navigateToInstaller } from '../routing';

const openModal = (site: Site, activeTab: number, source: string) => {
  const action = activeTab === 2 ? 'verify' : 'install';

  trackingCodeInstallerOpened(site, { action, source });
  bus.publish(
    trackingCodeModalOpened({
      site,
      activeTab: action,
    }),
  );
};

const shouldOpenInstaller = (site: Site) => {
  const { installed } = getState(site?.lastData);
  return !installed;
};

const open = ({
  site,
  fallback = noop,
  source,
  action = 'install',
}: {
  site: Site;
  fallback: () => void;
  source: string;
  action?: 'install' | 'verify';
}) => {
  if (shouldOpenInstaller(site)) {
    trackingCodeInstallerOpened(site, { action, source });
    navigateToInstaller(site);
  } else {
    fallback();
  }
};

export const show = (site: Site, activeTab: number, source: string): void => {
  const fallback = () => openModal(site, activeTab, source);
  if (source === 'Setup Hotjar Component') {
    fallback();
  } else {
    open({ site, source, fallback });
  }
};
